import React from 'react';
import TextInput from './../TextInput';
import isEqual from 'lodash-es/isEqual';
import {set, get} from '../../../utils/dotutils';

class UserControl extends React.Component {

    constructor(props) {
        super(props);
        this.getLayout = this.getLayout.bind(this)
    }

    fieldProps = (fields, name) => {
        const props = (Array.isArray(fields)) ? {} : (fields[name] || {});
        const def = this.props.props && this.props.props[name] || this.props[name] || null;
        if(def) {
            if(def.disabled) {
                if(typeof def.disabled === "object") {
                    props.disabled = props.disabled || get(def.disabled, name, false);
                } else {
                    props.disabled = props.disabled || def.disabled;
                }
            }
        }
        if(this.props.disabled) {
            if(typeof this.props.disabled === "object") {
                props.disabled = props.disabled || get(this.props.disabled, name, false);
            } else {
                props.disabled = props.disabled || this.props.disabled;
            }
        }
        return props;
    }

    setFieldValue = (field, value) => {
        if (field.indexOf("taxid") !== -1) {
            if (value === '') {
                value = null;
            }
        }
        let oldValue = get(this.props.value, field);
        if (!isEqual(oldValue, value)) {
            const v = Object.assign({}, this.props.value);
            set(v, field, value);
            this.setState({
                ...this.state
            });
            this.props.saveChanges((this.props.name || 'user'), v);
        }
    }

    saveChanges = (field, value) => {
        if (field.indexOf("taxid") !== -1) {
            if (value === '') {
                value = null;
            }
        }
        if(this.props.name) {
            this.setFieldValue(field, value);
        } else {
            this.props.saveChanges(field, value);
        }
    }

    // https://gist.github.com/ecarter/1423674
    mapOrder = (array, order, key) => {

        array.sort( function (a, b) {
            var A = a[key], B = b[key];

            if (order.indexOf(A) > order.indexOf(B)) {
                return 1;
            } else {
                return -1;
            }

        });

        return array;
    };

    getLayout(fields) {
        let key = 0;
        const lastnameFieldDef = this.fieldProps(fields, "lastname");
        let lastname = null;
        if(lastnameFieldDef.parent) {
            lastname = <TextInput key={++key} {...lastnameFieldDef} name="lastname" value={ this.props.value.lastname } label="Vezetéknév" saveChanges={ this.saveChanges }/>
            //ReactDOM.createPortal(lastname, lastnameFieldDef.parent);
        } else {
            lastname = <div key={++key} className="col-md-6">
                <TextInput {...lastnameFieldDef} name="lastname" value={ this.props.value.lastname } label="Vezetéknév" saveChanges={ this.saveChanges }/>
            </div>;
        }
        const firstnameFieldDef = this.fieldProps(fields, "firstname");
        let firstname = null;
        if(firstnameFieldDef.parent) {
            firstname = <TextInput key={++key} {...firstnameFieldDef} name="firstname" value={ this.props.value.firstname } label="Keresztnév" saveChanges={ this.saveChanges }/>
            //ReactDOM.createPortal(firstname, firstnameFieldDef.parent);
        } else {
            firstname = <div key={++key} className="col-md-6">
                <TextInput {...firstnameFieldDef} name="firstname" value={ this.props.value.firstname } label="Keresztnév" saveChanges={ this.saveChanges }/>
            </div>;
        }
        const taxidFieldDef = this.fieldProps(fields, "taxid");
        let taxid = null;
        if(taxidFieldDef.parent) {
            taxid = <TextInput key={++key} {...taxidFieldDef} name="taxid" value={this.props.value.taxid || ''}
                               label="Adószám" saveChanges={ this.saveChanges }/>
            //ReactDOM.createPortal(taxid, taxidFieldDef.parent);
        } else {
            taxid = <div key={++key} className="col-sm-6">
                <TextInput {...taxidFieldDef} name="taxid" value={this.props.value.taxid || ''}
                           label="Adószám" saveChanges={ this.saveChanges }/>
            </div>;
        }
        const eu_taxidFieldDef = this.fieldProps(fields, "eu_taxid");
        let eu_taxid = null;
        if(eu_taxidFieldDef.parent) {
            eu_taxid = <TextInput key={++key} {...eu_taxidFieldDef} name="eu_taxid" value={this.props.value.eu_taxid || ''}
                                  label="EU Adószám" saveChanges={ this.saveChanges }/>
            //ReactDOM.createPortal(eu_taxid, eu_taxidFieldDef.parent);
        } else {
            eu_taxid = <div key={++key} className="col-sm-6">
                <TextInput {...eu_taxidFieldDef} name="eu_taxid" value={this.props.value.eu_taxid || ''}
                           label="EU Adószám" saveChanges={ this.saveChanges }/>
            </div>;
        }
        const emailFieldDef = this.fieldProps(fields, "email");
        let email = null;
        if(emailFieldDef.parent) {
            email = <TextInput key={++key} {...emailFieldDef} name="email" value={ this.props.value.email } label="Email" saveChanges={ this.saveChanges }/>
            //ReactDOM.createPortal(email, emailFieldDef.parent);
        } else {
            email = <div key={++key} className="col-md-6">
                <TextInput {...emailFieldDef} name="email" value={ this.props.value.email } label="Email" saveChanges={ this.saveChanges }/>
            </div>;
        }
        const telnumFieldDef = this.fieldProps(fields, "telnum");
        let telnum = null;
        if(telnumFieldDef.parent) {
            telnum = <TextInput key={++key} {...telnumFieldDef} name="telnum" value={ this.props.value.telnum } label="Telefonszám" saveChanges={ this.saveChanges }/>
            //ReactDOM.createPortal(telnum, telnumFieldDef.parent);
        } else {
            telnum = <div key={++key} className="col-md-6">
                <TextInput {...telnumFieldDef} name="telnum" value={ this.props.value.telnum } label="Telefonszám" saveChanges={ this.saveChanges }/>
            </div>;
        }
        const fieldnames = (Array.isArray(fields)) ? fields : Object.keys(fields);
        const map = this.mapOrder([
            {field: /*firstnameFieldDef.parent === undefined && */(fieldnames.indexOf("name") !== -1 || fieldnames.indexOf("firstname") !== -1) ? firstname : null, name: "firstname"},
            {field: /*lastnameFieldDef.parent === undefined && */(fieldnames.indexOf("name") !== -1 || fieldnames.indexOf("lastname") !== -1) ? lastname : null, name: "lastname"},
            {field: /*taxidFieldDef.parent === undefined && */fieldnames.indexOf("taxid") !== -1 ? taxid : null, name: "taxid"},
            {field: /*eu_taxidFieldDef.parent === undefined && */fieldnames.indexOf("eu_taxid") !== -1 ? eu_taxid : null, name: "eu_taxid"},
            {field: /*emailFieldDef.parent === undefined && */(fieldnames.indexOf("email") !== -1) ? email : null, name: "email"},
            {field: /*telnumFieldDef.parent === undefined && */(fieldnames.indexOf("telnum") !== -1) ? telnum : null, name: "telnum"},
        ], (Array.isArray(fields)) ? fields : Object.keys(fields), 'name');
        return map.filter((item) => item.field !== null).map((item) => item.field);
    }

    render() {
        const fields = this.props.fields || ["name"];
        return this.props.layout ? this.props.layout(fields) : this.getLayout(fields);
    }

}

export default UserControl;